"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenConstants = require("@8x8/oxygen-constants");

var _CloseLargeIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseLargeIcon"));

var _ControlContainer = _interopRequireDefault(require("../styled/ControlContainer"));

var _ToastContainer = _interopRequireDefault(require("../styled/ToastContainer"));

var _ValueContainer = _interopRequireDefault(require("../styled/ValueContainer"));

var _ActionsContainer = _interopRequireDefault(require("../styled/ActionsContainer"));

var _Action = _interopRequireDefault(require("../styled/Action"));

var _getColor = _interopRequireDefault(require("../styled/utils/getColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Toast = function Toast(_ref) {
  var theme = _ref.theme,
      hideCloseControl = _ref.hideCloseControl,
      onCloseControlClick = _ref.onCloseControlClick,
      size = _ref.size,
      type = _ref.type,
      actions = _ref.actions,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["theme", "hideCloseControl", "onCloseControlClick", "size", "type", "actions", "children"]);

  var iconColor = (0, _getColor["default"])({
    theme: theme,
    type: type
  });
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_ToastContainer["default"], _extends({
    type: type,
    size: size
  }, props), /*#__PURE__*/_react["default"].createElement(_ValueContainer["default"], null, children), !!actions && /*#__PURE__*/_react["default"].createElement(_ActionsContainer["default"], null, actions.map(function (_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        callback = _ref2.callback;
    return /*#__PURE__*/_react["default"].createElement(_Action["default"], {
      onClick: callback,
      key: id
    }, title);
  })), !hideCloseControl && /*#__PURE__*/_react["default"].createElement(_ControlContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_CloseLargeIcon["default"], _extends({
    color: iconColor,
    onClick: onCloseControlClick
  }, (0, _oxygenConfig.getTestAttributes)('TOAST_CLOSE_ICON'))))));
};

Toast.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  hideCloseControl: _propTypes["default"].bool,
  onCloseControlClick: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(Object.values(_oxygenConstants.toastSizes)),
  type: _propTypes["default"].oneOf(Object.values(_oxygenConstants.toastTypes)),
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    callback: _propTypes["default"].func
  })),
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node])
};
Toast.defaultProps = {
  hideCloseControl: false,
  onCloseControlClick: undefined,
  size: _oxygenConstants.toastSizes.medium,
  type: _oxygenConstants.toastTypes.success,
  actions: undefined,
  children: ''
};

var _default = (0, _oxygenConfig.withTheme)(Toast, 'toast');

exports["default"] = _default;